import * as React from 'react';
import { Button } from '@bepure/tarkin';

declare const BASE_API_URL: string;
interface Props {
    sku: string;
}

interface State {
    email?: string;
    success?: boolean;
    submitted: boolean;
}

export class NotifyMe extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);

        this.state = {
            submitted: false,
        };
    }

    public render() {
        return (
            <div className="flex flex--column flex--justify_center info info--dark">
                {!this.state.submitted ?
                    <div>
                        <div className="flex--no-wrap flex flex--column flex--justify_center notify_me_input">
                        <input placeholder={' '} className={`input input__input ${this.isEmailInvalid() ? 'input--error' : ''}`} type="email" onChange={this.updateField('email')} />
                        <div className="input__labels">
                            <div className="text input__labels__label">Email</div>
                        </div>
                        {this.isEmailInvalid() ?
                            <span className={`input input__error_message ${!this.isEmailInvalid() ? 'input__error_message--hidden' : ''}`}>Please enter a valid email.</span>
                            :
                            <div />}
                        </div>
                        <Button id={'notify_back_in_stock'} ariaLabel={'Notify Me'} text={'Notify Me When Back In Stock'} className="btn btn--primary" onClick={this.notify} />
                    </div>
                    : this.state.success ?
                    <span>We'll notify you when we're back in stock!</span>
                    : this.state.success === false ?
                    <span className="text--error">Whoops, something went wrong - refresh and try again.</span>
                    :
                    <span />
                }
                </div>
        );
    }
    private isEmailInvalid = () => {
        if (this.state.submitted) {
            return !this.state.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.state.email);
        }
        return false;
    }

    private updateField = (field: string, value?: string) => {
        return (event: any) => {
            this.setState({
                ...this.state,
                [field]: value || event.target.value,
            });
        };
    }

    private submitNotificationRequest = async (customerEmail: string, productSku: string) => {
        return await fetch(`${BASE_API_URL}/v1/product/stock-notification-request`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-TYpe': 'application/json',
            },
            body: JSON.stringify({
                sku: productSku,
                email: customerEmail,
            }),
        }).then(response => {
            return response;
        });
    }

    private notify = () => {
        this.setState({
            submitted: true,
        }, () => {
            if (!this.isEmailInvalid()) {
                this.submitNotificationRequest(this.state.email!, this.props.sku).then(response => {
                    this.setState({
                        ...this.state,
                        success: response.ok,
                    });
                });
            }
        });
    }
}
